const AUTHORIZED_ENVIRONMENT_NAMES = ['PRD', 'DEV', 'TEST', 'QUA', 'COOP', 'OPS']
const PRODUCTION_ENVIRONMENT_NAME = 'PRD'

export default {
  name: 'AdnLogoAladin',
  props: {
    cooperativeName: {
      type: String,
      default: undefined
    },
    environmentName: {
      type: String,
      default: PRODUCTION_ENVIRONMENT_NAME,
      validator: val => AUTHORIZED_ENVIRONMENT_NAMES.includes(val)
    },
    homepageUrl: {
      type: [String, Object],
      default: '/'
    },
    isHomepage: {
      type: Boolean,
      default: false
    },
    showPreviousButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    notProductionEnvironment() {
      return this.environmentName !== PRODUCTION_ENVIRONMENT_NAME
    }
  },
  methods: {
    onClick() {
      return this.$emit('click')
    }
  }
}
